import React from 'react'

export default function TitleLeftIllustration() {
    return (
        <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="7.5" width="12" height="1" rx="0.5" fill="url(#paint0_linear_24488_21044)" />
            <rect x="11" y="4" width="1" height="8" rx="0.5" fill="#2BCFA1" />
            <defs>
                <linearGradient id="paint0_linear_24488_21044" x1="12" y1="8" x2="0" y2="8" gradientUnits="userSpaceOnUse">
                    <stop offset="0.25" stopColor="#2BCFA1" />
                    <stop offset="1" stopColor="#2BCFA1" stopOpacity="0.1" />
                </linearGradient>
            </defs>
        </svg>
    )
}
